import { useMutation } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

interface ChatRequest {
	message: string;
	conversationSummary?: string;
}

interface ChatResponse {
	success: boolean;
	response: string;
	summary: string;
	emotion: string;
	error?: string;
}

export function useMeetingChat(meetingId: string) {
	const http = useHttpClient();

	return useMutation({
		mutationFn: async ({ message, conversationSummary }: ChatRequest): Promise<ChatResponse> => {
			const response = await http.post(`/meeting_context/${meetingId}/chat`, {
				message,
				conversation_summary: conversationSummary,
			});
			return response.data;
		},
	});
}
